import { createStyles, makeStyles } from '@material-ui/core';

type Props = {
  marginBtn?: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    gridContent: {
      display: 'flex',
      padding: '5px 8px',
      backgroundColor: '#FCD3D3',
      margin: '5px 10px',
      borderRadius: '10px',
      textAlign: 'left',
      alignItems: 'center',
    },
    btn: {
      justifyContent: 'space-between!important',
      padding: '0px!important',
      width: '100%',
      margin: (props: Props) => `${props.marginBtn}!important`,
    },
    title: {
      textTransform: 'none',
      margin: 0,
      alignItems: 'center',
      display: 'flex',
      fontSize: '0.9rem',
      fontWeight: 500,
      color: '#4c4f53',
      textAlign: 'left',
    },
    iconLeft: {
      marginRight: 10,
      width: 20,
      height: 25,
    },
  }),
);

export default useStyles;
